/**
 * Static fake data for visual verification only (admin design preview and the
 * dev-only `?preview=1` render). It mints nothing and never hits an endpoint.
 */
import type { LuxuryGiftCardData } from './LuxuryGiftCard';

export const DEMO_GIFT_CARD: LuxuryGiftCardData = {
  headline: 'שובר מתנה',
  recipientName: 'נועה אברהמי',
  senderName: 'משפחת מנסור',
  message: 'מזל טוב! שיהיה לך יום מלא באור, פינוק ורוגע — מחכות לך בקליניקה.',
  occasion: 'יום הולדת',
  initialAmount: 750,
  balanceAmount: 520,
  balanceAvailable: true,
  balanceSyncedAt: new Date().toISOString(),
  currency: 'ILS',
  statusLabel: 'נוצל חלקית',
  active: true,
  expiresOn: '2027-06-30',
  lastCharacters: '4Q7T',
  logoUrl: null,
  qrValue: 'https://riham.co.il/gift/preview-example-token',
  brandName: 'RIHAM',
};

/** Same card, with Shopify unreachable — verifies the no-fallback state. */
export const DEMO_GIFT_CARD_NO_BALANCE: LuxuryGiftCardData = {
  ...DEMO_GIFT_CARD,
  balanceAmount: null,
  balanceAvailable: false,
  statusLabel: 'פעיל',
};
